import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from {
    transform: translate(-50%, 30px);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
`;

export const Container = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3000000001;
  min-width: 320px;
  max-width: 480px;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.$dark || '#2c3a4b'};
  color: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  animation: ${slideUp} 0.2s ease-out;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const Message = styled.span`
  font-size: 0.9rem;
  flex: 1;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UndoButton = styled.button`
  background: transparent;
  color: #6cb2ff;
  border: none;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 4px 8px;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover:not(:disabled) {
    color: #92c8ff;
  }

  &:disabled {
    color: #6c757d;
    cursor: not-allowed;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  color: #adb5bd;
  border: none;
  font-size: 1.2rem;
  line-height: 1;
  padding: 0 4px;
  cursor: pointer;

  &:hover {
    color: #fff;
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 3px;
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 2px;
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ percent: number }>`
  height: 100%;
  width: ${({ percent }) => percent}%;
  background-color: #6cb2ff;
  transition: width 0.2s linear;
`;
